/**
 * OfertaScreen — static legal-offer overlay at /oferta.
 *
 * Styled to prototype.jsx OfertaScreen (screens.jsx:923-944):
 *   - Card with T.title3 section heading ("Договор оферты")
 *   - Body text in T.subhead / lineHeight 1.6 per prototype
 *   - Numbered clauses with consistent spacing
 *   - Footer link in T.footnote / S.secondaryLabel
 *
 * Uses StaticPage atom for layout. usePlatformBack() registers navigate(-1)
 * on the TG BackButton. The same navigate(-1) callback is passed to
 * StaticPage.onBack so the visual back pill in PageHeader is consistent.
 *
 * Content is hardcoded inline as JSX (no ru.json, no useT) — per FTR-998
 * HomeScreen / inline-JSX convention. No CTA button (read-only legal text).
 *
 * Uses:
 *   - components/atoms: StaticPage, Card
 *   - hooks/usePlatformBack: TG back-button registration
 *   - react-router-dom: useNavigate
 *
 * Used by:
 *   - App.tsx (route /oferta, sibling of AppShell)
 */
import { useNavigate } from 'react-router-dom';
import { StaticPage, Card } from '../components/atoms';
import { usePlatformBack } from '../hooks/usePlatformBack';
import { S, T } from '../styles/tokens';

// ─── Legal clauses ────────────────────────────────────────────────────────────

const CLAUSES = [
  'Покупаешь товар на свои деньги.',
  'Не возвращаешь товар после получения кешбэка.',
  'Отзыв честный и соответствует требованиям маркетплейса.',
  'Awardy не несёт ответственности за модерацию маркетплейса.',
] as const;

// ─── OfertaScreen ─────────────────────────────────────────────────────────────

export default function OfertaScreen() {
  const navigate = useNavigate();
  const onBack = () => navigate(-1);

  // Registers navigate(-1) on the TG BackButton for hardware/OS back gestures.
  usePlatformBack();

  return (
    <StaticPage title="Оферта" onBack={onBack}>
      <Card p={16} r={20}>
        {/* Section heading — T.title3: 600 20px body, warm ink */}
        <div
          style={{
            font: T.title3,
            color: S.label,
            letterSpacing: -0.45,
            marginBottom: 10,
          }}
        >
          Договор оферты
        </div>

        {/* Lead-in paragraph */}
        <div
          style={{
            font: T.subhead,
            color: S.secondaryLabel,
            lineHeight: 1.6,
          }}
        >
          Awardy — сервис кешбэка за выполнение заданий. Принимая оферту, ты
          подтверждаешь:
        </div>

        {/* Numbered clauses */}
        <div style={{ marginTop: 12 }}>
          {CLAUSES.map((clause, i) => (
            <div
              key={i}
              style={{
                font: T.subhead,
                color: S.label,
                lineHeight: 1.6,
                marginTop: i === 0 ? 0 : 6,
              }}
            >
              {i + 1}. {clause}
            </div>
          ))}
        </div>

        {/* Footer link */}
        <div
          style={{
            marginTop: 16,
            font: T.footnote,
            color: S.secondaryLabel,
          }}
        >
          Полный текст: awardy.ru/oferta
        </div>
      </Card>
    </StaticPage>
  );
}
